import { BreakPoint } from '../types/BreakPoint';

export const Device = {
    tablet: `(min-width: ${BreakPoint.SCREEN_MD_MIN})`,
    tabletPortrait: `(min-width: ${BreakPoint.TABLET_PORTRAIT})`,
    desktop: `(min-width: ${BreakPoint.SCREEN_SM_MIN})`,
    phone: `(max-width: ${BreakPoint.PHONE})`
};
